import React from 'react';
import Navbar from './Navbar';
import Breadcrumbs from './Breadcrumbs';
import LanguageSelector from './LanguageSelector';
import SuperuserFarmPicker from './SuperuserFarmPicker';
import { useLang } from '../LanguageContext';
import { useAuth } from '../context/AuthContext';
import { useFarm } from '../context/FarmContext';
import { useSuperuserFarmPickerNavigate } from '../hooks/useSuperuserFarmPickerNavigate';
import { isGlobalRole } from '../utils/roles';
import './MainLayout.css';

const TELEGRAM_BOT_URL = process.env.REACT_APP_TELEGRAM_BOT_URL || 'https://t.me/shefagreen_bot';

export default function MainLayout({ children }) {
  const { t } = useLang();
  const { token, user, realUser, ready } = useAuth();
  const { farms, effectiveFarmId, contextOverrideId } = useFarm();
  const onSuperuserFarmChange = useSuperuserFarmPickerNavigate();
  const year = new Date().getFullYear();

  const farmValue = contextOverrideId || user?.farmId || effectiveFarmId || '';
  const showMobileFarmDock =
    ready &&
    Boolean(token) &&
    isGlobalRole(realUser?.role || user?.role) &&
    Array.isArray(farms) &&
    farms.length > 0;

  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="site-sticky-header">
        <Navbar />
      </div>
      <main
        className={`flex-fill shefa-page-main ${showMobileFarmDock ? 'shefa-main--with-farm-dock' : ''}`}
      >
        <Breadcrumbs />
        {children}
      </main>
      {showMobileFarmDock ? (
        <div className="shefa-mobile-farm-dock d-lg-none" role="region" aria-label={t('theme.farmMenu')}>
          <SuperuserFarmPicker
            farms={farms}
            value={farmValue}
            onChange={onSuperuserFarmChange}
            t={t}
            variant="dock"
          />
        </div>
      ) : null}
      <footer className="footer site-footer py-4">
        <div className="container site-footer__inner">
          <small className="site-footer__copyright">© {year} Shefa Green</small>
          <div className="site-footer__actions">
            <a
              className="site-footer__telegram"
              href={TELEGRAM_BOT_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-telegram-plane" aria-hidden="true" />
              <span>{t('home.footer.telegram')}</span>
            </a>
            <LanguageSelector variant="compact" />
          </div>
        </div>
      </footer>
    </div>
  );
}
